<template>
	<div>
		<div class="fluid containerp">
			<div class="conectBar">
				<div id="editConPhone" class="con_innd" style="min-height: 500px; border: 1px solid #fff;">
					<div v-if="phoneNav.navheader.mStyle!=2" class="navheader ms1" :style="phoneNav.navheader">
						<p id="back" class="back" :style="[phoneNav.backStyle,{lineHeight:parseInt(phoneNav.navheader.height)-20+'px'}]">
							<img src="https://diy.xiaohucloud.com/static/image/img/crt_13.png" /></p>
						<p class="nav_logo" :style="phoneNav.logoStyle">
							<span v-if="phoneNav.namenumber==1">{{phoneNav.mainText.web_name}}</span>
							<img :style="phoneNav.navheaderImg" v-if="phoneNav.namenumber==2" :src="phoneNav.mainText.web_logo" />
						</p>
						<p class="navClick" :style="[phoneNav.iconStyle,{lineHeight:parseInt(phoneNav.navheader.height)-20+'px'}]"><img :src="phoneNav.mainText.web_icon" /></p>
					</div>
					<div v-if="phoneNav.navheader.mStyle==2" class="navheader ms2" :style="phoneNav.navheader">
						<p class="navClick" :style="[phoneNav.iconStyle,{lineHeight:(parseInt(phoneNav.navheader.height)-20+'px')}]"><img :src="phoneNav.mainText.web_icon" /></p>
						<p id="backIndex" class="back nav_logo" :style="phoneNav.logoStyle">
							<span v-if="phoneNav.namenumber==1">{{phoneNav.mainText.web_name}}</span>
							<img :style="phoneNav.navheaderImg" v-if="phoneNav.namenumber==2" :src="phoneNav.mainText.web_logo" />
						</p>
						<div class="search_icon">
							<img id="headerSearch" :src="phoneNav.navheader.url||'https://diy.xiaohucloud.com/static/image/search_icon.png'" />
						</div>
						<p id="placeholderTxt" class="placeholderTxt"><input id="searchValue" type="text" :placeholder="showData[param.lang][0]" class="searchCon" />
							<button @click="goProduct()">{{showData[param.lang][1]}}</button>
						</p>
					</div>
					<div id="navBg" class="bg_net0"></div>
					<div id="menu" :class="['navigation',{ms1_nav:phoneNav.navheader.mStyle!=2,ms2_nav:phoneNav.navheader.mStyle==2}]">
						<ul class="navItem" :style="{background:router.hoverStyle.background}">
							<li v-if="router.isLanguage" class="mltilingual-li">
								<div id="mltilingual" class="mltilingual-phone" :style="router.langugeQx.setDivStyle">
									<div v-if="router.langugeQx.styleType==1" class="styleType1">
										<div class="title" :style="router.langugeQx.setFontStyle">
											<span>{{curMltilingual}} <em></em></span>
										</div>
										<ul class="ul_item">
											<li v-for="(item,index) in showLang" :key="index">
												<a :href="router.langugeQx.domain+'?lang='+item.code">{{item.lang_name}}</a>
											</li>
										</ul>
									</div>
									<div v-if="router.langugeQx.styleType==2" class="styleType2">
										<a v-for="(item,index) in showLang" :key="index" :href="router.langugeQx.domain+'?lang='+item.code" :style="router.langugeQx.setFontStyle"><span>{{item.lang_name}}</span></a>
									</div>
								</div>
							</li>
							<li v-if="item.is_show&&item.url!='newsDetail'" v-show="item.url!='productDetail'" class="first_item" v-for="(item,it) in navItem" :key="it">
								<div :class="['la_item',{isHover:item.is_show},{active:activeRoute == item.id}]" @click="goDesign(item)" :style="router.tTextStyle"><i v-if="item.secondNav.length" class="g-fr over" :style="router.hoverStyle">{{item.secondNav.length}}</i>{{item.column_name}}</div>
								<ul v-if="item.secondNav.length" class="seconNav">
									<li v-if="second.is_show&&item.url!='newsDetail'" v-for="(second,sec) in item.secondNav" :key="sec">
										<div :class="['sec_item',{isHover:second.is_show},{active:activeRoute == second.id}]" @click="goDesign(second)" :style="router.tTextStyle"><i v-if="second.thirdNav.length" class="g-fr over" :style="router.hoverStyle">{{second.thirdNav.length}}</i>{{second.column_name}}</div>
										<ul v-if="second.thirdNav.length" class="thirdNav">
											<li v-if="third.is_show&&item.url!='newsDetail'" :class="['thir_item',{active:activeRoute == third.id}]" :style="router.tTextStyle" v-for="(third,thirIndex) in second.thirdNav" @click="goDesign(third)" :key="thirIndex">
												{{third.column_name}}
											</li>
										</ul>
									</li>
								</ul>
							</li>
						</ul>
					</div>
					<div :class="['conect_inner',{con_padd:state.footer.isShow}]">
						<!--导航 -->
						<template v-for="(i,tIndex) in getDataCur.stream" class="g-cf in_outer">
							<!--满屏容器-->
							<div :id="i.allId" v-if="i.tName=='fullScreen'" style="min-height: 10px;" :class="['in_inner fullScreen',{'enter':i.isStreamColumn}]">
								<!--lyf 满屏 2020-07-21-->
                 <img class="fullScreenBjImg" :src="i.mImage.url" style="display: none;" />
                <div :id="tIndex" class="resizeMe" :style="i.conStyle">
									<!--div v-if="ite.isShow" v-for="(ite,index) in i.itemInner" :itemInner="i.itemInner" :itemMdata="ite" :posCom="'free'+tIndex" :index="index" :is="ite.tName" class="outmodule"></div-->
									<mConet v-for="(irt,index) in i.itemInner" class="outmodule" :key="index" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner"></mConet>
								</div>
							</div>
							<!--自由容器-->
							<div :id="i.allId" v-if="i.tName=='freeContainer'" :class="['in_inner freeContainer',{'enter':i.isStreamColumn}]">
								<div class="resizeMe" :style="i.conStyle">
									<!--div v-if="ite.isShow" v-for="(ite,index) in i.itemInner" :itemInner="i" :itemMdata="ite" :posCom="'free'+tIndex" :index="index" :is="ite.tName"></div-->
									<mConet v-for="(irt,index) in i.itemInner" :class="[{outmodule:irt.fullScreen}]" :key="index" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner"></mConet>
									<!--uiDialog v-if="i.isEdit" :itemMdata='i' :editDial='{rTitle:"设置自由容器"}'></uiDialog-->
								</div>
							</div>
							<!--多列排版-->
							<div :id="i.allId" v-if="i.tName=='multiColumnContainer'" :class="['in_inner resizeMe multi_con g-cf', {'enter':i.isStreamColumn}]">
								<div class="resizeMe" :style="[i.conStyle,{visibility:i.isShow?'visible':'hidden'}]">
									<div v-for="(it,index) in i.labelTitle" :style="[{height:i.conStyle.height,width:it.styleCon.width}]" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]" v-if="it.isShow">
										<div class=" clm_inner" :style="i.conStyle">
											<div class="area_conn" :style="i.conStyle">
												<template v-for="(imy,inde) in it.itemInner">
													<mConet v-if="imy.isShow" class="outmodule" :itemMdata="imy" :key="inde" :itemInner="it.itemInner"></mConet>
												</template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!--标签展示-->
							<div :id="i.allId" v-if="i.tName=='labelContainer'" :class="['in_inner labelContainer',{'enter':i.isStreamColumn}]">
								<div class="tit_con" :class="[{labelListOne:i.diretionM==1,labelListTwo:i.diretionM==2,righterdUl:i.setulStyle==3&&i.diretionM==2}]">
									<ul class="g-cf" id="labelTitle" :class="['g-cf',{centerUl:i.setulStyle==1&&i.diretionM==1,leftUl:i.setulStyle==2&&i.diretionM==1,rightUl:i.setulStyle==3&&i.diretionM==1}]" :style="i.labelUlStyle">
										<li v-for="(ite,index) in i.labelTitle" class="labelList" :style="i.labelTitleBasis">
											<p class="title" :style="[{borderRadius:i.labelTitleBasis.borderRadius},ite.curItem==i.curItem?i.labelTitleStyleHover:i.labelTitleStyle]">{{ite.labelTitle}}</p>
										</li>
										<!--p class="addTitle" @click="addTitle(i)">添加标签</p-->
									</ul>
									<div class="lbl_con">
										<div :id="tIndex" v-for="(it,index) in i.labelTitle" v-show="i.isShow&&it.curItem == i.curItem" :style="it.conStyle" :class="['resizeMe conStyle',{'enter':i.isStreamColumn}]">
											<div class="ateralLabel" :style="it.conStyle">
												<template v-if="ilbl.isShow&&!ilbl.fontShowilbl" v-for="(ilbl,dex) in it.itemInner">
													<!--div class="outmodule" :itemMdata="ite" :posCom="'labelContainer'+index" :index="index" :is="ite.tName"></div-->
													<mConet class="outmodule" :key="dex" :itemMdata="ilbl" :itemInner="it.itemInner"></mConet>
													<!--mConet v-if="it.curItem == i.curItem" :key="dex" :itemMdata="ite" :itemInner="i.itemInner" class="outmodule"></mConet-->
												</template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!--滑屏容器-->
							<div :data-index="tIndex" v-if="i.tName=='swiperContainer'&&i.isShow" :class="['swiperContainer in_inner g-cf']" :style="i.zinStyle">
								<div :id="i.allId" class="swiper-container">
									<div class="swiper-wrapper">
										<div class="swiper-slide" v-for="(it,index) in i.labelTitle" :class="['clm','clm'+index]" :style="it.layoutOuterStyle">
											<div class="area_conn" :style="it.zinStyle">

												<template v-for="(imy,inde) in it.itemInner">
													<mConet v-if="imy.isShow" :itemMdata="imy" :key="inde" :itemInner="it.itemInner"></mConet>
												</template>
											</div>
										</div>
									</div>
								</div>
								<!-- 如果需要分页器 -->
								<div class="swiper-pagination"></div>
								<!-- 如果需要导航按钮 -->
								<!--div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div-->
								<!-- 如果需要滚动条 -->
								<div class="swiper-scrollbar"></div>
							</div>
							<!--滑屏容器-->
						</template>
					</div>
				</div>
				<div v-if="state.footer.isShow" class="nav-footer phoneedit">
					<footer>
						<div v-for="(item,index) in state.footer.itemNav" @click="goDesign(item,'footer')" :key="index" v-bind:class="['f_item',{active:activeRoute == item.id}]">
							<span :style="[{backgroundImage:state.footer.iconNav},item.iStyle]" :class="['rout_ctive','tab-' + index]"></span>
							<em>{{item.text}}</em>
						</div>
					</footer>
				</div>
			</div>
		</div>
		<div class="erweimaPhone">
			<input type="text" v-model="param.domain_url" :title="param.domain_url" readonly="readonly" style="border: 1px solid #ccc; margin-bottom: 20px; height: 30px; line-height: 30px; width: 230px;" />
		<!-- 	<img v-if="param.type==2" :src="'http://qr.topscan.com/api.php?w=250&text='+param.domain_url+'?v='+new Date().getTime()" /> -->
      <img v-if="param.type==2" :src="'http://qr.topscan.com/api.php?w=250&text='+param.domain_url" />
			<img v-if="param.type!=2" :src="'http://qr.topscan.com/api.php?w=250&text='+wxpt_url" />
			<p class="p2">扫一扫，在手机查看网站</p>
		</div>
	</div>
</template>
<script>
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	import api from '@/api/$ajax.js'
	import mConet from './mConet.vue'

	export default {
		name: 'xIndex2',
		components: {
			mConet
		},
		props: [],
		updated: function() {
			this.$nextTick(function() {
				console.log("$nextTick")
			})
		},

		created() {
     
     console.log(this.$route)
			var ts = this;
			var info = JSON.parse(localStorage.getItem("info"));
			console.log(info.domain_m);

			if(ts.param.type == 3 || ts.param.type == 4 || ts.param.type == 5 || ts.param.type == 6 || ts.param.type == 7) {
				ts.param.domain_url = ts.wxpt_url;
			}
			//ts.param.type = info.domain_m;
			//debugger;
			api.get('/api/data/columnList?template_id=' + ts.param.id + "&version_id=" + ts.param.version_id, false, {}, function(r) {
				if(r.code == 422) {
					return;
				}
				ts.navItem = r.data.list;
				if(ts.param.param == "index") {
					ts.param.column_id = r.data.list[0].id;
				}
				ts.getData(ts.param);
			});

			var temp = ts.$route.params.param;
			ts.setDelayed(temp);
			ts.getWebInfo();
			ts.getAddress();
			ts.getData2();

			var objAll = {
				id: ts.param.id,
				type: ts.param.type,
				token: ts.param.token,
				column_id: ts.param.version_id + "000",
				version_id: ts.param.version_id
			}
			ts.getAllSite(objAll);
			ts.getLang();
			setTimeout(function() {
				mProductShow.initLoad(ts.param.company_id);
			}, 400);

		},
		mounted() {
			var ts = this;
			var stream = ts.getDataCur.stream;
			for(let j = 0; stream.length > j; j++) {
				if(stream[j].tName == 'labelContainer') {
					ts.labelContainer = stream[j];
					//ts.labelContainerId = "labelContainer" + j;
					xIndex2.label(ts.labelContainer.allId, ts.labelContainer);
					//debugger
					//dzit.labelHover("#labelContainerId" + j, stream[j]);
					/*for(var b = 0; stream[j].labelTitle.length > b; b++) {
						var itemInner2 = stream[j].labelTitle[b].itemInner;
						for(var a = 0; itemInner2.length > a; a++) {
							//var mleft2 = itemInner2[a].parentStyle.left;
							//var mwidth2 = itemInner2[a].parentStyle.width;
							var minwidth2 = 332; //$(window).width()
							var changeLeft2 = Math.round(mleft2 / minwidth2 * 10000) / 100.00 + "%";
							var changeWidth2 = Math.round(mwidth2 / minwidth2 * 10000) / 100.00 + "%";

							//$("#" + ts.labelContainer.allId).find(".ateralLabel").eq(b).find(".hove_con").eq(a).css("left", changeLeft2);
							//$("#" + ts.labelContainer.allId).find(".ateralLabel").eq(b).find(".hove_con").eq(a).css("width", changeWidth2);
						}
					}*/

				} else if(stream[j].tName == "swiperContainer") {

					hoverAction.swiperHover(stream[j].allId, stream[j]);
				}
			};
			setTimeout(function() {
				xIndex2.back();
			}, 400);

		},
		computed: {
			activeRoute() {
				return this.$route.path;
			}
		},
		data() {
			return {
				isMultiColumn: false,
				isConLeave: false,
				id: this.$route.params.id,
				preview: '/t2/prev/' + this.$route.params.id + "/",
				wxpt_url: "https://wxp.xiaohucloud.com?domain=" + this.$route.query.domain_url + "&companyid=" + this.$route.query.company_id + "&lang=" + this.$route.query.lang + "&versionid=" + this.$route.query.mobile_version_id + "&type=" + this.$route.query.type + '&v=' + new Date().getTime(),
				wx_url: "https://wxp.xiaohucloud.com?ad=" + JSON.stringify({
					domain: this.$route.query.domain_url,
					companyid: this.$route.query.company_id,
					lang: 1,
					versionid: this.$route.query.mobile_version_id,
					v: new Date().getTime()
				}),
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					column_id: this.$route.query.column_id,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id,
					version_id: this.$route.query.mobile_version_id
				},
				showData: {
					en: ['Please enter the product you are searching', 'search'],
					cn: ["请输入要搜索的产品", "搜索"]
				},
				itemMdata: {},
				editDial: {
					isEdit: false,
					rTitle: "设置自由容器",
				},
				contextMenuData: {
					// the contextmenu name(@1.4.1 updated)
					menuName: this.$utils.guid(),
					axios: {
						x: null,
						y: null
					},
					//Menu options (菜单选项)
					menulists: [{
							fnHandler: 'moveDownFloor',
							btnName: '设置为全站模块'
						},
						{
							fnHandler: 'copyItem',
							btnName: '复制模块'
						}
					]
				},
				isAddNew: false,
				showLang: [],
				curMltilingual: "",
				token: this.$route.query.token,
				labelContainer: '',
				labelContainerId: "labelContainer" + this.tIndex,
				address: ''
			}
		},
		methods: {
			showUl() {
				$('.styleType1 .ul_item').animate({
					height: 'toggle'
				})
				event.stopPropagation()
			},
			getLang() {
				var ts = this;
				api.get('/api/data/lang', false, {}, r => {
					if(r.code == 422) {
						return;
					}
					var langList = r.data.lang_list;
					ts.showLang = [];
					for(var i = 0; langList.length > i; i++) {
						//debugger
						if(langList[i].code == ts.param.lang) {
							ts.curMltilingual = langList[i].lang_name;
						}
						ts.showLang = langList;
					}
				});
			},
			goProduct() {
				let ts = this;
				let paramUrl = "";
				let columnList = JSON.parse(localStorage.getItem("columnList")) || [];
				for(let i = 0; columnList.length > i; i++) {
					if(columnList[i].url == "productList") {
						paramUrl = columnList[i].id;
					}
				}
				window.open(ts.preview + paramUrl + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type +
					'&pc_version_id=' + ts.param.pc_version_id + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang + '&keyword=' + $('#searchValue').val())
			},
			getAddress() {
				var ts = this;
				api.get('/api/diy/getDomain', true, {}, function(data) {
					ts.address = data.data.domain_m;
					console.log(ts.address)
				});
			},

			getData2() {
				let ts = this;
				ts.router.navBarItem = [];
				api.get('/api/data/columnList?template_id=' + ts.param.id + "&m=index&version_id=" + ts.param.version_id, false, {}, r => {
					if(r.code == 422) {
						console.log(r.message);
						return;
					}

					var list = r.data.list;
					//debugger;
					var firstList = [];
					for(let i = 0; list.length > i; i++) {
						//console.log(list[i].parent_id=1);
						list[i].secondNav = [];
						if(list[i].parent_id == 0) {
							firstList.push(list[i])
						}
					}
					for(let i = 0; firstList.length > i; i++) {
						for(let k = 0; list.length > k; k++) {
							list[k].thirdNav = [];
							if(firstList[i].id == list[k].parent_id) {
								firstList[i].secondNav.push(list[k])
							}
						}
					}

					for(let i = 0; firstList.length > i; i++) {
						for(let k = 0; firstList[i].secondNav.length > k; k++) {
							//var thirdNav = firstList[i].secondNav[k]
							for(let j = 0; list.length > j; j++) {
								//firstList[i].secondNav[k].thirdNav = [];
								if(firstList[i].secondNav[k].id == list[j].parent_id) {
									firstList[i].secondNav[k].thirdNav.push(list[j])
								}
							}
						}
					}

					ts.navItem = firstList;

				});
			},
			getWebInfo() {
				var ts = this;
				api.get('/api/data/getWebInfo', true, {}, function(data) {
					ts.phoneNav.mainText = data.data;
				});
			},

			goDesign(item, flag) {
				if(flag != 'footer' && !item.is_enable) {
					return;
				}
				var link = item.id;
				if(!link) {
					return;
				}

				let ts = this;
				if(item.url && item.url.indexOf("http") > -1) {
					location.href = item.url;
					return;
				}
				if(link) {
					if(Number(link)) {
						location.href = ts.preview + link + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_url + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang;
					} else if(link.indexOf("http") != -1) {
						location.href = link;
					} else {
						location.href = ts.preview + link + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_url + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang;
					}
				}
			},
			...mapActions([
				"getData", "saveloca"
			]),
			...mapMutations([
				'orderbyId', 'setDelayed', 'setCurOrder', 'pushItemStream', "pushItemPosCom", "pushItemStreamItem", "getAllSite", "change", "setPosSite"
			])
		},
		computed: {
			activeRoute() {
				return this.param.param;
			},
			...mapGetters(["state", "getDataCur", "router", "phoneNav", "itemCon"])
		},
	}
</script>

<style lang="scss" scoped>
	.containerp {
		width: 420px;
		height: 800px;
		overflow-y: hidden;
		overflow-x: hidden;
		margin-left: 30%;
		position: relative;
		background: url(/static/image/phonebg.png) no-repeat center;
	}

	.navigation {
		position: absolute;
		height: 90%;
	}

	.conectBar {
		position: relative;
	}

	.nav-footer {
		position: absolute;
		bottom: 0;
		width: 405px;
		margin-left: 5px;
		left: 0;
	}

	.navheader .navClick {
		margin-top: 0;
	}

	.navheader {
		padding-right: 10px;
		position: relative !important;
	}

	.con_innd {
		margin-left: 4px;
		height: 668px;
		width: 405px;
		overflow: hidden;
		margin-left: 4px;
		position: relative;
		overflow-x: hidden;
		overflow-y: auto;
		margin-right: 10px;
		margin-top: 55px;
	}

	.swiperHover .containerp .conect_inner {
		height: 100%;
	}

	.containerp .conect_inner {
		overflow-x: hidden;
		overflow-y: auto;
		margin-top: 0;
		/*border: 1px solid red !important;*/
		background-color: #fff;
		position: relative;
		margin-right: auto;
		.columnLayout {
			position: relative;
			margin-left: -45%;
			margin-right: -45%;
		}
		.con_innd {}
	}

	.in_outer {
		position: relative;
	}

	.pos_con {
		.inner {
			width: 100%;
			margin: 0 auto;
		}
	}

	#labelTitle {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		text-align: center;
		width: auto;
		margin-bottom: 0;
		position: relative;
		.labelList {
			display: block;
			float: left;
			text-align: center;
			z-index: 100;
			width: auto;
			box-sizing: border-box;
			.title {
				position: relative;
				cursor: pointer;
				width: 100%;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				i {
					position: absolute;
					top: 0px;
					right: 10px;
					line-height: 20px;
					display: none;
				}
			}
			.title:hover i {
				display: block;
			}
		}
	}

	.cur .title {
		background: red !important;
		color: #FFFFFF !important;
	}

	.ateralShow {
		display: block;
	}

	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background-color: #b2b2b2;
		width: 16px;
		-webkit-border-radius: 16px;
		-moz-border-radius: 16px;
		border-radius: 16px;
	}
	/*//@import "../../../../static/css/pcwebout.css";
	.container .conect_inner {
		width: 990px;
		background-color: #fff;
		position: relative;
		margin: 0 auto;
		.columnLayout {
			position: relative;
			margin-left: -45%;
			margin-right: -45%;
		}
	}

	.in_outer {
		position: relative;
	}

	.container .warning {
		border: 1px dashed red;
	}

	.in_inner {
		border: 1px dashed #fff;
		position: relative;
		.del_icon {
			text-align: left;
		}
		.multi_edit {
			position: absolute;
			top: -40px;
			width: 450px;
			height: 40px;
			line-height: 40px;
			display: none;
			span {
				cursor: pointer;
				margin-right: 10px;
			}
		}
	}

	.in_inner:hover {
		border-color: #ccc;
		.multi_edit {
			display: block;
		}
	}

	.multi_con {
		.clm {
			border: 1px dashed #fff;
			float: left;
			position: relative;
		}
		.clm2 {
			width: 50%;
		}
		.clm3 {
			width: 33.13%;
		}
		.clm4 {
			width: 25%;
		}
		.clm5 {
			width: 20%;
		}
	}

	.longitud {
		.tit_con {
			float: left;
			width: 20%;
			ul {}
		}
		.long_con {
			float: left;
			width: 80%;
		}
	}

	.ateralLabel {
    display: none;
		ul {
			li {
				float: left;
				width: 100px;
				text-align: center;
			}
		}
		.long_con {}
	}
	.ateralLabelAll .ateralLabel:first-child{
    display: block;
  }
	.container .enter {
		border: #5874d8 1px dashed;
	}

	.addMern {
		width: 990px;
		margin: 0 auto;
		.dragNew {
			min-height: 100px;
			padding-top: 35px;
			text-align: center;
			background-color: rgba(204, 204, 204, 0.36);
			p {
				text-align: center;
				cursor: pointer;
				width: 150px;
				margin: 0 auto;
				line-height: 30px;
				height: 30px;
				background-color: #ccc;
				border: 1px solid #666;
				border-radius: 4px;
			}
		}
	}*/
</style>



// WEBPACK FOOTER //
// src/components/t2/prev/index.vue